<template>
  <div class="context-header">
    <div class="row">
      <div v-for="(value, name) in fields" class="col-sm-4">
        <b>{{name}}:</b> {{value}}
      </div>
    </div>
    <audio :src="audioUrl" controls preload="none" class="my-3" style="width: 100%"/>
  </div>
</template>
<script setup lang="ts">
import { computed } from 'vue'
import { useNcsConfig } from 'ncs'
import { useContextFields } from './context_fields'

const props = defineProps<{
  document: Record<string, any>,
  text: Record<string, any>,
}>()

const ncsConfig = useNcsConfig()

const audioUrl = `${ncsConfig.app.relativeUrlRoot}/audio/${props.text.text.id}.mp3`
const fields = computed(() => useContextFields(props.document, props.text.text, [], []))
</script>
